import React from "react";
import { playPitch } from "@/lib/audio";

const WHITE = ["C", "D", "E", "F", "G", "A", "B"];
const HAS_SHARP = new Set(["C", "D", "F", "G", "A"]);
const idx = (p) => Number(p.slice(-1)) * 7 + WHITE.indexOf(p[0]);
const KW = 18;

// Keyboard with labelled range bands above it (hand split, vocal ranges).
export const RangeKeyboard = ({ from = "C2", to = "C6", bands = [], split, tints = [], testId = "range-keyboard" }) => {
  const lo = idx(from);
  const keys = Array.from({ length: idx(to) - lo + 1 }, (_, i) => { const d = lo + i; return `${WHITE[d % 7]}${Math.floor(d / 7)}`; });
  const BH = 26;
  const top = bands.length * BH + 12;
  const w = keys.length * KW;
  const xOf = (p) => (idx(p) - lo) * KW;
  const tintOf = (p) => tints.find((t) => idx(p) >= idx(t.lo) && idx(p) <= idx(t.hi));
  return (
    <div className="overflow-x-auto" data-testid={testId}>
      <svg viewBox={`0 0 ${w + 2} ${top + 112}`} className="mx-auto w-full min-w-[560px]" role="img" aria-label={bands.map((b) => `${b.label}: ${b.lo} to ${b.hi}`).join("; ")}>
        {split && (
          <g data-testid={`${testId}-split`}>
            <line x1={xOf(split)} x2={xOf(split)} y1={2} y2={top} stroke="#EF4444" strokeWidth="2.5" strokeDasharray="5 3" />
          </g>
        )}
        {bands.map((b, k) => {
          const x1 = xOf(b.lo), x2 = xOf(b.hi) + KW, y = k * BH + 4;
          return (
            <g key={b.label} data-testid={`${testId}-band-${k}`}>
              <rect x={x1 + 1} y={y} width={x2 - x1 - 2} height={BH - 6} rx="6" fill={b.color} opacity="0.9" />
              <text x={(x1 + x2) / 2} y={y + 14} fontSize="11" fontWeight="700" textAnchor="middle" fill="#0B0D12" fontFamily="sans-serif">{b.label}</text>
            </g>
          );
        })}
        {keys.map((p) => {
          const t = tintOf(p);
          return (
            <g key={p} onClick={() => playPitch(p)} className="cursor-pointer">
              <rect x={xOf(p)} y={top} width={KW - 1} height={100} rx="2" fill={t ? t.color : "#FAF8F4"} stroke="#57534E" strokeWidth="0.8" />
              {(p[0] === "C" || p === split) && <text x={xOf(p) + KW / 2 - 0.5} y={top + 92} fontSize="8.5" textAnchor="middle" fill="#0B0D12" fontWeight="700" fontFamily="monospace">{p}</text>}
            </g>
          );
        })}
        {keys.slice(0, -1).map((p) => HAS_SHARP.has(p[0]) && (
          <rect key={`b${p}`} x={xOf(p) + KW - 6} y={top} width={11} height={62} rx="1.5" fill="#0B0D12" onClick={() => playPitch(`${p[0]}#${p.slice(-1)}`)} className="cursor-pointer" />
        ))}
        {split && <line x1={xOf(split)} x2={xOf(split)} y1={top} y2={top + 106} stroke="#EF4444" strokeWidth="2.5" strokeDasharray="5 3" />}
      </svg>
    </div>
  );
};
